import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ClassStatusNumeric } from '@fitness-force/enum';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'class-status',
  templateUrl: './class-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class ClassStatusComponent implements OnInit {
  activeStatus: any;
  columnData: BehaviorSubject<any> = new BehaviorSubject(null);
  additionData: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor() {}

  ngOnInit(): void {
    this.columnData.subscribe({
      next: (cData: any) => {
        let index = 0;
        for (let [key, value] of Object.entries(ClassStatusNumeric)) {
          if (
            (cData?.class_status && value == cData?.class_status) ||
            (cData?.status && value == cData?.status)
          ) {
            this.activeStatus = { name: value, key };
          }
          index++;
        }
      },
    });
  }
}
